import getReturnUrl from './get-return-url.js';

const openLoadCard = async (theapp, context, amount) => {
	console.log('openLoadCard called');

	let mvcmywidget = theapp.getMvcMyWidget();
	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;
	
	var base_uri = await theapp.getRemoteWalletUrl();
	var uri;

	// load card from remote wallet


	let _currency = context.currency;
	let _card = context.currentcard;
	let _scheme = context.currentscheme;


	uri = base_uri + '?route=' + (start_conditions.remote_wallet_route ? start_conditions.remote_wallet_route : 'currencycard');

	uri += '&ring=' + (start_conditions.remote_wallet_ring ? start_conditions.remote_wallet_ring : '2'); //ring=2 ask to authentify

	let web3_provider_url = (_scheme && _scheme.network && _scheme.network.ethnodeserver ? _scheme.network.ethnodeserver.web3_provider_url : null)
	let currencyaddress = (_currency ? _currency.address : null);
	let returnurl = getReturnUrl(theapp);


	// scheme
	if (web3_provider_url)
	uri += '&web3url=' + theapp.encodebase64(web3_provider_url);

	// currency
	if (currencyaddress)
	uri += '&tokenaddress=' + currencyaddress;

	// card to load
	if (_card && _card.address)
	uri += '&to=' + _card.address;

	if (amount)
	uri += '&amount=' + amount;

	// return url (no callback for a load)
	if (returnurl)
	uri += '&returnurl=' + theapp.encodebase64(returnurl);
	
	// additional parameters
	if (start_conditions.remote_wallet_params) {
		try {
			let arr = Object.entries(start_conditions.remote_wallet_params);

			for (var i = 0; i < (arr ? arr.length : 0); i++) {
				uri += '&' + arr[i][0] + '=' + arr[i][1];
			}
		}
		catch(e) {
			console.log('exception in PayWidget.onLoadCard parsing start_conditions.remote_params_string: ' + e);
		}
		
	}

	// encode in base64 to safely travel accross mail and messaging
	uri = base_uri + '?b64url=' + theapp.encodebase64(uri);

	var options = {};

	if (start_conditions.pop_up === true) {
		options.pop_up = true;
	}

	theapp.gotoUrl(uri, options);
}

export default openLoadCard;